import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { HomepageService } from '@app/_services/homepage.service';
import { CartService, QuotationCartService } from '@app/_services';
import { MobileMenuItem } from '@interfaces/mobile-menu-item';
import { MobileMenuService } from '@services/mobile-menu.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService, UserService } from '@app/_services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NavigationExtras, Router, UrlSerializer, RouterLink } from '@angular/router';
import { DirectionService } from '@app/_services/direction.service';
import * as _ from 'lodash';
import { SectorPageService } from '@app/_services/sectorPage.service';
import { SharedService } from '@app/_services/shared.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslateHelper } from '@app/_helpers';
import { SiteService } from '@app/_services/site.service';
import { CurrencySelectComponent } from '../../../../_components/inputs/currency-select/currency-select.component';
import { MobileLinksComponent } from '../mobile-links/mobile-links.component';
import { CollapseDirective, CollapseItemDirective, CollapseContentDirective } from '../../../../shared/directives/collapse.directive';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { NgClass, NgIf, NgStyle, NgFor, AsyncPipe, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass, IconComponent, RouterLink, NgIf, CollapseDirective, CollapseItemDirective, CollapseContentDirective, MobileLinksComponent, CurrencySelectComponent, NgStyle, NgFor, AsyncPipe, KeyValuePipe, TranslateModule]
})
export class MobileMenuComponent implements OnDestroy, OnInit, AfterViewInit {
    private destroy$: Subject<any> = new Subject();

    isOpen = false;
    categorylinks: any[] = [];
    sectorlinks: any[] = [];
    userDetails;
    sector;
    searchDropdown;
    staticPages: any = {};

    constructor(
        private homepageService: HomepageService,
        private router: Router,
        private direction: DirectionService,
        private urlSerializer: UrlSerializer,
        private userService: UserService,
        private sectorPageService: SectorPageService,
        private sharedService: SharedService,
        private authService: AuthenticationService,
        public cart: CartService,
        public quotationCart: QuotationCartService,
        public mobilemenu: MobileMenuService,
        public translateService: TranslateService,
        public deviceDetector: DeviceDetectorService,
        public translateHelper: TranslateHelper,
        public siteService: SiteService
    ) { }

    currentCountry;
    ngOnInit(): void {
        this.sharedService.pageSubject$.subscribe(page => {
            this.sector = page;

            this.categorylinks = [];
            this.sectorlinks = [];

            this.homepageService.categories$.subscribe((response) => {
                this.sectorlinks = response;
            }, (error => {
                //console.log(error);
            }));
            if (page && page != 'homepage') {
                this.sectorPageService.categories$.subscribe((response) => {
                    this.categorylinks = response;
                }, (error => {
                    //console.log(error);
                }));
            }

            /* this.sharedService.getCountries().subscribe((response)=>{
                response
             }); */

            this.sharedService.currentCountry$.subscribe((country) => this.currentCountry = country);
        });

        this.mobilemenu.isOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => this.isOpen = isOpen);
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });

        this.homepageService.getPages().subscribe(pages => {
            if (pages) {
                _.forEach(pages, (page) => {
                    this.staticPages[page.section] = []
                });
                _.forEach(pages, (page) => {
                    this.staticPages[page.section].push(page)
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit(): void {
        this.sharedService.searchDropdownSubject$.subscribe((searchDropdown) => {
            this.searchDropdown = searchDropdown;
        });
    }

    onItemClick(event: MobileMenuItem): void {
        this.mobilemenu.close();

        // if (event.data && event.data.language) {
        //     console.log(event.data.language); // change language
        // }
    }

    changeLangage(lang: string) {
        this.authService.currentUser.subscribe((user: any): any => {
            if (user?.preferances?.language != lang)
                this.userService.setLanguage({ lang: lang }).subscribe((res) => {
                    if (res.code == 200) {
                        this.translateService.setDefaultLang(lang);
                        this.translateService.use(lang);

                        let navigationExtras: NavigationExtras;

                        const tree = this.router.parseUrl(this.router.url);

                        let url: any = this.urlSerializer.parse(this.router.url);

                        let stateUrl = this.router.url.split('/');
                        let commands = [];

                        stateUrl.forEach((segment) => {
                            if (segment == "" || segment == "en" || segment == "ar") return;

                            if (segment.includes('?')) {
                                commands.push(segment.split('?')[0]);
                                if (!_.isEmpty(url.queryParams) || !_.isEmpty(tree.queryParams)) {
                                    //commands.push({queryParams: url.queryParams??tree.queryParams});
                                    navigationExtras = {
                                        queryParams: url.queryParams ?? tree.queryParams
                                    };
                                }

                            } else {
                                commands.push(segment);
                            }

                        });

                        commands.unshift('/'.concat(lang))


                        /* this.route.queryParams.pipe(take(1)).subscribe((params)=>{
                            if(!_.isEmpty(params))
                                 commands.push(params);
                
                
                        }); */
                        this.mobilemenu.close();
                        this.router.navigate(commands, navigationExtras);


                        lang == 'ar' ? this.direction.value = 'rtl' : 'ltr';
                    } else {
                        //console.log("Error setting user prefered language");
                    }

                }, (error) => {
                    //console.log("Error setting user prefered language");
                });
        });



    }

    searchDropdownToggle(event: MobileMenuItem) {
        this.onItemClick(event);
        this.searchDropdown.open();
    }

    logout() {
        this.authService.logout().subscribe();
    }

    changeCountry(country) {
        this.mobilemenu.close();
        this.sharedService.currentCountrySubject$.next(country);
    }
    currencyChange(event) {
        if (event) this.mobilemenu.close();
    }
}
